export enum ReviewStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJCETED = 'rejected',
}

export interface ReviewData {
  totalReview: number;
  review: Review[];
}

export interface Review {
  id: number;
  review: string;
  createdAt: Date;
  updatedAt: Date;
  user?: User;
}

export interface User {
  id: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface LikeData {
  totalLikes: number;
  like: Like[];
}

export interface Like {
  id: number;
  createdAt: Date;
  user: User;
}
